"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_property_decorator_1 = require("vue-property-decorator");
var vue_1 = __importDefault(require("vue"));
var SearchByTrendingContent = /** @class */ (function (_super) {
    __extends(SearchByTrendingContent, _super);
    function SearchByTrendingContent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.allCollections = null;
        _this.selectedCollections = [];
        _this.fetchingallCollections = false;
        _this.fetchCollectionsPageUrl = '/local/api/collections';
        _this.allCongresses = null;
        _this.selectedCongresses = [];
        _this.fetchingAllCongresses = false;
        _this.fetchCongressesPageUrl = '/local/api/congresses';
        _this.allOptions = [];
        return _this;
    }
    SearchByTrendingContent.prototype.created = function () {
        var _this = this;
        this.selectedCollections = this.initialSearchCollectionIds;
        this.selectedCongresses = this.initialSearchCongresses;
        this.$watch(function () { return _this.refreshFilters; }, function () {
            if (_this.refreshFilters) {
                _this.selectedCollections = _this.initialSearchCollectionIds;
                _this.selectedCongresses = _this.initialSearchCongresses;
            }
        }, { immediate: true, deep: true });
        this.$watch(function () { return _this.initialSearchTopicIds; }, function () {
            _this.getallCollections();
            _this.getAllCongresses();
        }, { immediate: true, deep: true });
    };
    SearchByTrendingContent.prototype.printLabel = function (label) {
        return this.truncateLabels ? label.slice(0, this.truncateLabels) : label;
    };
    SearchByTrendingContent.prototype.getallCollections = function () {
        var _this = this;
        this.fetchingallCollections = true;
        var queryString = '';
        if (this.per_page)
            queryString += "?per_page=".concat(this.per_page);
        if (this.relation) {
            queryString += "&relation=".concat(this.relation);
        }
        if (this.initialSearchTopicIds && this.initialSearchTopicIds.length) {
            queryString += "&topic_ids[]=" + this.initialSearchTopicIds.join('&topic_ids[]=');
        }
        var apiUrl = "".concat(this.fetchCollectionsPageUrl, "?").concat(queryString);
        return this.http
            .get(apiUrl)
            .then(function (res) {
            var _a, _b;
            if (!((_b = (_a = res.data) === null || _a === void 0 ? void 0 : _a.page) === null || _b === void 0 ? void 0 : _b.data)) {
                throw new Error('Response data is empty.');
            }
            return res.data.page;
        })
            .then(function (page) {
            _this.allCollections = page.data;
        })
            .finally(function () {
            _this.fetchingallCollections = false;
            _this.setAllOptions();
        });
    };
    SearchByTrendingContent.prototype.getAllCongresses = function () {
        var _this = this;
        this.fetchingAllCongresses = true;
        var apiUrl = "".concat(this.fetchCongressesPageUrl, "/").concat(this.model);
        if (this.per_page)
            apiUrl += "?per_page=".concat(this.per_page);
        if (this.initialSearchTopicIds && this.initialSearchTopicIds.length) {
            apiUrl += "&topic_ids[]=" + this.initialSearchTopicIds.join('&topic_ids[]=');
        }
        return this.http
            .get(apiUrl)
            .then(function (res) {
            if (!res.data || !res.data.page || !res.data.page.data) {
                throw new Error('Response data is empty.');
            }
            return res.data.page;
        })
            .then(function (page) {
            _this.allCongresses = page.data;
        })
            .finally(function () {
            _this.fetchingAllCongresses = false;
            _this.setAllOptions();
        });
    };
    SearchByTrendingContent.prototype.setAllOptions = function () {
        var _this = this;
        var _a;
        var allOptionsArr = (_a = this.allCollections) === null || _a === void 0 ? void 0 : _a.concat(this.allCongresses);
        this.allOptions = [];
        if (allOptionsArr) {
            this.allOptions = allOptionsArr.sort(function (a, b) {
                return b.created_at.localeCompare(a.created_at);
            });
            this.allOptions = this.allOptions.filter(function (item, key) {
                return key <= _this.per_page - 1;
            });
        }
    };
    SearchByTrendingContent.prototype.toggleOption = function (id, type) {
        if (this.loading)
            return false;
        if (this.isSelected(id, type)) {
            if (type == 'congress') {
                // @ts-ignore
                this.selectedCongresses = this.selectedCongresses.filter(function (item) {
                    return item != id;
                });
            }
            else {
                // @ts-ignore
                this.selectedCollections = this.selectedCollections.filter(function (item) {
                    return item != id;
                });
            }
        }
        else {
            if (type == 'congress') {
                // @ts-ignore
                this.selectedCongresses.push(id);
            }
            else {
                // @ts-ignore
                this.selectedCollections.push(id);
            }
        }
        if (type == 'congress') {
            this.$emit('update-search-congresses', this.selectedCongresses);
        }
        else {
            this.$emit('update-search-collections', this.selectedCollections);
        }
    };
    SearchByTrendingContent.prototype.isSelected = function (id, type) {
        if (type == 'congress') {
            // @ts-ignore
            return this.selectedCongresses.find(function (item) { return item == id; });
        }
        // @ts-ignore
        return this.selectedCollections.find(function (item) { return item == id; });
    };
    __decorate([
        (0, vue_property_decorator_1.Prop)({ required: true })
    ], SearchByTrendingContent.prototype, "http", void 0);
    __decorate([
        (0, vue_property_decorator_1.Prop)({ default: '' })
    ], SearchByTrendingContent.prototype, "label", void 0);
    __decorate([
        (0, vue_property_decorator_1.Prop)({ default: 15 })
    ], SearchByTrendingContent.prototype, "per_page", void 0);
    __decorate([
        (0, vue_property_decorator_1.Prop)({ default: null, required: true })
    ], SearchByTrendingContent.prototype, "model", void 0);
    __decorate([
        (0, vue_property_decorator_1.Prop)({ default: null })
    ], SearchByTrendingContent.prototype, "relation", void 0);
    __decorate([
        (0, vue_property_decorator_1.Prop)({ default: [] })
    ], SearchByTrendingContent.prototype, "initialSearchTopicIds", void 0);
    __decorate([
        (0, vue_property_decorator_1.Prop)({ default: [] })
    ], SearchByTrendingContent.prototype, "initialSearchCollectionIds", void 0);
    __decorate([
        (0, vue_property_decorator_1.Prop)({ default: [] })
    ], SearchByTrendingContent.prototype, "initialSearchCongresses", void 0);
    __decorate([
        (0, vue_property_decorator_1.Prop)({ default: false })
    ], SearchByTrendingContent.prototype, "loading", void 0);
    __decorate([
        (0, vue_property_decorator_1.Prop)({ default: false })
    ], SearchByTrendingContent.prototype, "refreshFilters", void 0);
    __decorate([
        (0, vue_property_decorator_1.Prop)({ default: null })
    ], SearchByTrendingContent.prototype, "truncateLabels", void 0);
    SearchByTrendingContent = __decorate([
        (0, vue_property_decorator_1.Component)({
            components: {},
        })
    ], SearchByTrendingContent);
    return SearchByTrendingContent;
}(vue_1.default));
exports.default = SearchByTrendingContent;
